export default "/images/b18e9b4c3cd4d64955dbb0c2ee0fa20b.avif";